import {
    BORDER_GRAY,
    GREE_1,
    GREE_3,
    PLANTEI_DARK,
    WHITE
} from "../../utils/colors";
import Button from "../data_entry/Button";
import {EyeOutlined, ShoppingCartOutlined} from "@ant-design/icons";
import styled from "styled-components";
import imagePlaceholder from "../../assets/imgs/image-placeholder.jpg";
import {moneyMask} from "../../utils/utils";
import PrescriptionBadge from "./PrescriptionBadge";


const ProductCardWrapper = styled.div`
    position: relative;
    border: 1px solid ${BORDER_GRAY};
    border-radius: 10px;
    overflow: hidden;
    background: ${WHITE};
    transition: all 0.3s;
    height: 100%;
    cursor: pointer;

    &:hover {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
        transform: translateY(-4px);
    }

    &:hover .product-image img {
        transform: scale(1.1);
    }

    &:hover .product-overlay {
        opacity: 1;
    }
`;

const ProductImageBox = styled.div`
    position: relative;
    overflow: hidden;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
`;

const ProductImg = styled.img`
    width: 100%;
    height: 250px;
    object-fit: cover;
    transition: transform 0.5s;

    @media (max-width: 768px) {
        height: 200px;
    }
`;

const ProductOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.5s;
`;

const OverlayButton = styled.button`
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: none;
    background: ${GREE_1};
    color: ${WHITE};
    font-size: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.3s;

    &:hover {
        background: ${GREE_3};
    }
`;

const ProductContent = styled.div`
    text-align: center;
    padding: 20px 16px;
`;

const ProductTitle = styled.a`
    display: block;
    font-size: 16px;
    font-weight: 600;
    color: ${PLANTEI_DARK};
    margin-bottom: 12px;
    cursor: pointer;
    transition: color 0.3s;
    line-height: 1.4;

    &:hover {
        color: ${GREE_1};
    }
`;

const OldPrice = styled.del`
    font-size: 16px;
    color: #999;
    margin-right: 8px;
`;

const CurrentPrice = styled.span`
    font-size: 18px;
    font-weight: 600;
    color: ${GREE_1};
`;

const DetailButton = styled(Button)`
    margin-top: 16px;
    border-radius: 20px;
    height: 40px;
    font-weight: 600;
    background: ${GREE_1};
    border-color: ${GREE_3};
    color: ${WHITE};

    &:hover {
        background: ${GREE_3} !important;
        border-color: ${GREE_3} !important;
        color: ${WHITE} !important;
    }
`;

const PrescriptionBadgeWrapper = styled.div`
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 1;
    cursor: pointer;
`;




export default function ProductCard({
                                            product,
                                            onDetail,

                                        }) {
    return (
        <ProductCardWrapper onClick={() => onDetail(product)}>
            <ProductImageBox className="product-image">
                {product.requires_prescription && (
                    <PrescriptionBadgeWrapper>
                        <PrescriptionBadge/>
                    </PrescriptionBadgeWrapper>
                )}
                <ProductImg src={product.image || imagePlaceholder} alt={product.name} onError={(e) => { e.target.src = imagePlaceholder; }}/>
                <ProductOverlay className="product-overlay">
                    <OverlayButton>
                        <EyeOutlined/>
                    </OverlayButton>
                </ProductOverlay>
            </ProductImageBox>
            <ProductContent>
                <ProductTitle >
                    {product.name}
                </ProductTitle>
                <div>
                    {product.originalPrice && (
                        <OldPrice>R$ {moneyMask(product.originalPrice)}</OldPrice>
                    )}
                    <CurrentPrice>R$ {moneyMask(product.price)}</CurrentPrice>
                </div>
                <DetailButton
                    icon={<ShoppingCartOutlined/>}
                >
                    Ver detalhes
                </DetailButton>
            </ProductContent>
        </ProductCardWrapper>
    );
}